import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { convertToObj, getScreenName } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { getCustomQuery } from '../../Parenting/common';
import { dataSlots, getUsDataById, isUserFromIndia } from './constant';
import { ArtWrapper, ContentBody } from './styled';
import AdsBanner from '../AdsBanner';
import {
  fireClickAmazonCard,
  fireImpressionAmazonCard,
} from './instrumentation';
import { fireEvent } from '../../../Utils/fireEvent';

export default function ArticleContent(props) {
  const {
    data,
    query_add,
    isUsUser,
    amazonAffiliateData,
    modifiedHtmlString,
    showAdBanner,
  } = props;
  const router = useRouter();
  const [adHtmlString, setAdHtmlString] = useState(modifiedHtmlString);
  useEffect(() => {
    let element = document.querySelector('.article_data');
    // console.log("element", element);
    checkChildNodes(element);
  }, []);
  const [slotsShown, setSlotsShown] = useState();
  const checkChildNodes = (element) => {
    if (element?.children?.length > 0) {
      // console.log("element.children", element.children[1]);
      for (let i = 0; i < element.children.length; i++) {
        if (
          element.children[i].localName === 'p'
          // || element.children[i].localName === "span"
        ) {
          checkFurtherNode(element.children[i]);
        } else {
          checkChildNodes(element.children[i]);
        }
      }
    }
  };
  const checkFurtherNode = (element) => {
    const object = containsTag(element, 'strong');
    if (object.length > 0) {
      for (let i = 0; i < object.length; i++) {
        coverWithTag(object[i].index, 'h2');
      }
    } else {
      checkChildNodes(element);
    }
  };

  function containsTag(element, tag) {
    const arr = [];
    //childNodes used for all nodes present including text nodes and children used for nodes except text
    // if (element?.children?.length > 0) {
    if (element?.childNodes?.length == 1) {
      for (let i = 0; i < element?.children?.length; i++) {
        if (element.children[i].localName == tag) {
          arr.push({ index: element?.children[i] });
        }
      }
    }
    return arr;
  }

  function coverWithTag(el, newTagName) {
    let new_node = document.createElement(newTagName);
    // for replacing child
    // var attr = el.attributes;
    // for (var i = 0, len = attr.length; i < len; ++i) {
    //     n.setAttribute(attr[i].name, attr[i].value);
    // }
    new_node.style.fontSize = '16px';
    new_node.style.color = 'rgba(62, 62, 62, 0.87)';
    // n.innerHTML = el.innerHTML;
    // el.parentNode.replaceChild(n, el);
    let parent = el.parentNode;
    parent.removeChild(el);
    new_node.appendChild(el);
    parent.appendChild(new_node);
  }

  const onClickOfBody = (e) => {
    e.preventDefault();
    const complete_url = e.target?.closest('a')?.href?.split('?');
    if (!complete_url) return;

    const web_url = complete_url[0];
    const query_param = complete_url[1];
    let query_in_obj = {};
    if (query_param) {
      query_in_obj = convertToObj(query_param);
    }
    const custom_query = { ...query_add, ...query_in_obj, ...router.query };
    router.push(web_url + getCustomQuery(custom_query), '', {
      locale: getRouterLocale(router),
    });
  };

  const isInViewport = (el) => {
    const rect = el?.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const handleScroll = () => {
    for (let i = 0; i < 5; i++) {
      let idsArray = '';
      const box = document.querySelector(`.box_${i}`);
      const isVisible = box ? isInViewport(box) : null;
      const itemPresent = JSON.parse(localStorage.getItem('eventFired'));

      if (isVisible && itemPresent != i) {
        const amazonData = getUsDataById(
          data?.id ? JSON.stringify(data?.id) : '',
        );
        box.onclick = fireClickAmazonCard.bind(
          this,
          amazonData?.carouselData?.[i],
        );
        idsArray = i;
        localStorage.setItem('eventFired', JSON.stringify(idsArray));
        fireImpressionAmazonCard(amazonData?.carouselData?.[i]);
      }
    }
  };

  useEffect(() => {
    try {
      const insRegex = /<ins\b[^>]*>/gi;
      const matches = modifiedHtmlString.match(insRegex);
      const numberOfInsTags = matches ? matches.length : 0;
      setSlotsShown(matches);
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    localStorage.removeItem('eventFired');
  }, [data?.id]);

  const createObserver = function (handleIntersection, options, element) {
    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(element);
    return observer;
  };
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.4,
    };
    const elements = document.querySelectorAll('.adsWrapper');

    elements?.forEach((item, index) => {
      const callback = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            fireEvent({
              category: 'impression_ad_in_general_screen',
              screen_name: getScreenName(),
              parent: 'in_article_ad',
              support_variable: index + 1,
            });
            observer.unobserve(item);
          }
        });
      };
      const observer = createObserver(callback, options, item);
    });
    if (isUserFromIndia()) {
      // Create a temporary DOM element
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = modifiedHtmlString;

      // Find the div with class foreignAd
      let foreignAdDiv = tempDiv.querySelector('.foreignAd');

      // Replace it with the new content
      if (foreignAdDiv) {
        foreignAdDiv.outerHTML = `<a href="https://mylofamily.com/product/baby-diaper-pants-small-s-size-4-8-kgs-42-count-leak-proof-lightweight-rash-free-12-hours-protection-2378"><img src= "https://images.myloapp.in/NestJsUploads/1725971154328-1080X1080_DDUspsFirst_UpdatedPri-e-(1).webp" alt="Baby Diapers"/></a><p>Discover All Night Comfort with <a href="https://mylofamily.com/product/baby-diaper-pants-small-s-size-4-8-kgs-42-count-leak-proof-lightweight-rash-free-12-hours-protection-2378"><b>Mylo Diaper Pants</b></a> </p>`;
      }

      setAdHtmlString(tempDiv.innerHTML);
    }

    // window.googletag = window.googletag || { cmd: [] };
    // googletag.cmd.push(function () {
    //     InArticleAds?.map((item) => {
    //         const { adPath, adSizes, adSlot } = item;
    //         const adWrapper = document.getElementById(adSlot);
    //         if (adWrapper) {
    //             googletag
    //                 .defineSlot(adPath, adSizes, adSlot)
    //                 .addService(googletag.pubads());
    //             googletag.pubads().enableSingleRequest();
    //             googletag.pubads().collapseEmptyDivs();
    //             googletag.enableServices();
    //             googletag.cmd.push(function () {
    //                 googletag.display(adSlot);
    //             });
    //         }
    //     });
    // });

    // return () => {
    //     googletag.cmd.push(function () {
    //         googletag.destroySlots();
    //     });
    // };
  }, []);
  // useEffect(() => {
  //     googletag.cmd.push(() => {
  //         googletag.pubads().refresh();
  //     });
  // }, [data]);
  return (
    <ArtWrapper>
      {/* <ContentTitle>{data?.title}</ContentTitle> */}
      <ContentBody
        normal
        className="article_data"
        dangerouslySetInnerHTML={{
          __html: !showAdBanner ? data?.body : adHtmlString,
        }}
        // dangerouslySetInnerHTML={{
        //     __html: isUsUser
        //         ? amazonAffiliateData.body
        //         : modifiedHtmlString,
        // }}
        onClick={onClickOfBody}
      ></ContentBody>
      {slotsShown?.map((slot, index) => {
        return (
          <AdsBanner
            key={'adSlot' + index}
            data-ad-format="fluid"
            data-ad-slot={dataSlots[index]}
            data-ad-layout="in-article"
          />
        );
      })}{' '}
    </ArtWrapper>
  );
}
